module.exports = __webpack_public_path__ + "img/特价商品.a9baf114.png";